import React, { useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import LoginForm from './LoginForm'
import SetNewPasswordForm from './SetNewPasswordForm'
import { useNavigate, useParams } from 'react-router-dom'
import Button from '../formfields/Button'
import GuestUserLoginForm from './GuestUserLoginForm'
import SingleSignOn from './SingleSignOn'
import ExternalUserLoginForm from './ExternalUserLoginForm'

type Props = {
    loginOptions: null | ObjectStringKeyAnyValue
    authChallenge: ObjectStringKeyAnyValue | null
    setAuthChallenge: React.Dispatch<React.SetStateAction<any>>
}


function ChooseLoginType({
    loginOptions,
    authChallenge,
    setAuthChallenge
}: Props) {

  //  const {
  //  } = useContext(GlobalContext)

    const navigate = useNavigate()
    const { checklistId, assetId } = useParams()
    const [showForm, setShowForm] = useState<string | null>()

    const guestLoginPermitted = loginOptions && (
        loginOptions['Guest'] ||
        loginOptions['guest'] ||
        (loginOptions['Checklists'] && loginOptions['Checklists'].includes('guest')) ||
        (loginOptions['Checklists'] && loginOptions['Checklists'].includes('Guest'))
    ) ? true : false

    const cognitoLoginPermitted = loginOptions && (
        loginOptions['cognito'] ||
        loginOptions['Cognito'] ||
        loginOptions['email'] ||
        loginOptions['Email'] ||
        (loginOptions['Checklists'] && loginOptions['Checklists'].includes('email')) ||
        (loginOptions['Checklists'] && loginOptions['Checklists'].includes('Email')) ||
        (loginOptions['Checklists'] && loginOptions['Checklists'].includes('cognito')) ||
        (loginOptions['Checklists'] && loginOptions['Checklists'].includes('Cognito'))
    ) ? true : false


    const externalIndividualLogin = loginOptions && loginOptions['externalIndividual'] ? true : false

    // console.log('loginOptions', loginOptions)
    // console.log('guestLoginPermitted', guestLoginPermitted)
    // console.log('cognitoLoginPermitted', cognitoLoginPermitted)

    return <div className={`w-full flex flex-col gap-2`}>

        <h3 className={`font-righteous text-2xl text-brand-dark mb-4`}>Welcome to Checqr!</h3>
      
        {showForm === 'email' ? <LoginForm
            authChallenge={authChallenge}
            setAuthChallenge={setAuthChallenge}
            setShowForm={setShowForm}
        /> : ''}

        {showForm === 'guest' ? loginOptions && <GuestUserLoginForm
            pin={loginOptions['Guest']['pin']}
            setShowForm={setShowForm}
        /> : ''}


            {externalIndividualLogin && checklistId && <ExternalUserLoginForm
            
            />}


        {!showForm && <div className={`w-full flex flex-col gap-2`}>

            {(!checklistId || cognitoLoginPermitted) && <Button
                onClick={() => setShowForm(`email`)}
                text={'Log in with email'}
                variant={'secondary'}
                size={'big'}
                id={`loginWithEmail`}
                sameWindow={true}
            />}

            {loginOptions && guestLoginPermitted && <Button
                onClick={() => setShowForm(`guest`)}
                text={loginOptions['Guest']['pin'] ? `Log in with PIN` : 'Guest log in'}
                variant={'secondary'}
                size={'big'}
                id={`loginAsGuest`}
                sameWindow={true}
            />}


        </div>}

        {(loginOptions || !showForm) && <SingleSignOn />}

    </div>
}
export default ChooseLoginType